import styled from 'styled-components';
import media from 'src/styles/Media.styled';

import {
    StyledFilterContent,
    StyledQuickFilterBorder,
} from 'src/pages/orders/components/quickFilters/QuickFilters.styled';

export const TabGridContianer = styled.ul`
    margin: 0;
    padding: 0;
    width: 100%;
    display: grid;
    grid-auto-rows: 3em;
    grid-template-columns: repeat(7, 2fr) 1.2fr;
    gap: 0px;
    box-sizing: border-box;

    ${media.mediumDevice`
        grid-template-columns: repeat(7,2fr) 1.2fr;
    `}
    ${media.smalDevice`
        grid-template-columns: repeat(6,2fr);
    `}
    ${media.mobileDevice`
        grid-template-columns: ${({ isCondensedViewMobile }) =>
        isCondensedViewMobile ? 'repeat(2,2fr)' : 'repeat(3,2fr)'};
        gap: 0px;
    `}
`;

export const StyledTabContentContianer = styled.li`
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    background-color: ${({ isSelected }) =>
        isSelected ? '#FFFFFF' : '#EBEDED'};
    border: 0.5px solid #d7dbdb;
    opacity: 1;
    height: 100%;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};
`;

export const TabContent = styled(StyledFilterContent)`
    height: 95%;
    width: 100%;
    /* margin-left: 19px;
    margin-right: 10px; */
    min-width: 70%;
    justify-content: center;
    align-items: center;
    padding: 0 10px;

    ${media.mediumDevice`
        padding: 0 0.5rem;
    `}
    ${media.smalDevice`
        padding: 0 1rem;
    `}
    ${media.mobileDevice`
        margin-left: 1px;
        margin-right: 3px;
        padding: 0 0.4rem;
        width: 86%;
    `}
`;

export const TabSelectedBorder = styled(StyledQuickFilterBorder)``;

export const TabContentFont = styled.p`
    display: block;
    margin: 0;
    text-align: ${({ webTextAlign }) => (webTextAlign ? webTextAlign : 'center')};
    letter-spacing: 0px;
    color: ${({ isSelected }) => (isSelected ? '#1010EB' : '#202124')};
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    line-height: 16px;
    opacity: 1;
    ${media.smalDevice`
        text-align: center;
    `}
    ${media.mobileDevice`
        text-align: center;
    `}
`;
